import Task from "./Task";
import {type} from '../util/util'
import his from './history'
import supreme from '../supreme'
export default {
  taskStack:[],
  abandonTaskStack:[],
  // 栈里新增一个任务
  add(params){
    var task=new Task(params);
    this.taskStack.push(task);
    return task;
  },
  getStack(){
    return this.taskStack;
  },
  setStack(task){
    if(type.isArray(task)){
      this.taskStack = task.slice();
    }else if(type.isObject(task)){
      this.taskStack.push(task);
    }
  },
  //
  addTask(task){
    this.taskStack.push(task);
    return task;
  },
  // 出栈一个任务
  pop(){
   var task = this.taskStack.pop();
   his.asyncTaskStack(this.taskStack);
   this.abandonTaskStack.push(task);
  },
  // 把vue对象填充到task 中
  fillVueComponentToTask(vue,queryObject){
    var isFirstTask=false;
    var task;
    for(var i=0;i<this.taskStack.length;i++){
      if(this.taskStack[i].gid==queryObject.url_gid){
        isFirstTask=true;
        task=this.taskStack[i];
        this.taskStack[i].vue=vue;
        this.taskStack[i].pathName=vue.$route.path;
        this.taskStack[i].name=vue.$route.name;
        break;
      }
    }
    // 当一个页面时候会调用次方法
    if(!isFirstTask){
      var  params ={url_gid:queryObject.url_gid,name:vue.$route.name};
      task=this.add({pathName:vue.$route.path,params:supreme.$.extend(params,queryObject)},);
      task.vue=vue;
    }
    return task
  },
  // 按名称回退
  backToTaskByName(name){
    var flag;
    var result;
    for(var i=this.taskStack.length-1;i>=0;i--){
      var task=this.taskStack[i];
      var n = name.replace("/","").replace("\\","").toLowerCase();
      var tname=task.pathName.replace("/","").replace("\\","").toLowerCase();
      if(n==tname){
        flag=i;
        result=task;
        break;
      }
    }
    if(flag!=undefined){
      this.taskStack=this.taskStack.splice(0,flag+1);
    }
    return result;
  },
  //按步数回退
  backToTaskByStep(step){
    var flag;
    var result;
    var topIndex=this.taskStack.length-1;
    if(step>topIndex){
      return ;
    }else{
      this.taskStack=this.taskStack.splice(0,topIndex-step+1);
      result=this.getLastTask();
    }
    return result;
  },
  //判断任务栈是否为空
  isEmpty(){
    return !this.taskStack.length
  },
  //获取栈顶的task
  getCurrentTask(){
    return this.getLastTask();
  },
  //获取栈顶的task
  getLastTask(){
    if(this.taskStack.length>0){
      return this.taskStack[this.taskStack.length-1];
    }else{
      return null;
    }

  },
  // 从出栈的的任务中获取task
  getTaskInAbandonTaskStack(gid){
    var task ;
    for(var i=0;i<this.abandonTaskStack.length;i++){
      var tempTask = this.abandonTaskStack[i];
      if(tempTask.gid==gid){
        task=tempTask;
      }
    }
    return task;
  },
  //清除任务栈
  clear(){
    his.clear();
    for(var i=0;i<this.taskStack.length;i++){
      this.taskStack[i].vue&&this.taskStack[i].vue.clearCache();
    }
    this.taskStack=[];
    this.abandonTaskStack=[];

  },
}
